export const LogoMark = ({ className = "h-7 w-auto" }) => (
  <svg viewBox="0 0 60 40" className={className} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M8 21v-7a4 4 0 0 1 4-4h14a4 4 0 0 1 4 4v7" />
    <rect x="3" y="19" width="6" height="13" rx="3" />
    <rect x="29" y="19" width="6" height="13" rx="3" />
    <path d="M9 25h20M9 32h20M6 32v4M32 32v4" />
    <path d="M43 2h10l3 12H40z" />
    <path d="M48 14v22M44 36h8" />
  </svg>
);

export const Logo = ({ onClick, testId = "brand-logo" }) => (
  <button data-testid={testId} onClick={onClick} className="group flex items-center gap-3 text-[#E6D9BC]">
    <LogoMark className="h-8 w-auto transition-transform duration-500 group-hover:-rotate-3" />
    <span className="font-sans text-xl tracking-tight">Space Wise</span>
  </button>
);
